const i18nGenerated = {
  modifiedDate: '2021-02-02T10:47:14.034Z',
  source: 'en',
  targets: ['es', 'fr', 'pt', 'ru'],
  data: {
    en: {
      English: 'English',
      Restore: 'Restore',
    },
    es: {
      'Add new': 'Añadir nuevo',
      'Input search text...': 'Buscar...',
      'Clear filter': 'Limpiar Filtro',
      Cancel: 'Cancelar',
      OK: 'Aceptar',
      Yes: 'Sí',
      No: 'No',
      Description: 'Descripción',
      Spanish: 'Español',
      English: 'Inglés',
      'My profile': 'Mi perfil',
      'Close session': 'Cerrar sesión',
      Settings: 'Configuración',
      hrs: 'hrs',
      French: 'Francés',
      'Edit task': 'Editar tarea',
      'Are you sure delete this task?': '¿Está seguro que desea eliminar esta tarea?',
      Delete: 'Eliminar',
      Reader: 'Lector',
      Contributor: 'Contribuidor',
      Permissions: 'Permisos',
      Welcome: 'Hola',
      'Select entity': 'Seleccione entidad',
      'Set Entity Title': 'Nombre de la entidad',
      'Set Entity Type': 'Tipo de la entidad',
      Add: 'Añadir',
      'Add New': 'Añadir nuevo',
      'Select group': 'Seleccione grupo',
      'Select groups': 'Seleccione grupos',
      'Select organization': 'Seleccione organización',
      'Select permissions': 'Seleccione permisos',
      'Entity Type': 'Tipo de Entidad',
      'Select roles': 'Seleccione roles',
      'Select user': 'Seleccione usuario',
      'Select users': 'Seleccione usuarios',
      'Select visibility': 'Seleccione visibilidad',
      'General Properties': 'Propiedades Generales',
      Name: 'Nombre',
      'Please enter a name': 'Por favor entre un nombre',
      Save: 'Guardar',
      Reset: 'Reestablecer',
      'Add members to group': 'Añadir miembros al grupo',
      'Are you sure want remove': 'Está seguro que quiere eliminar',
      User: 'Usuario',
      Search: 'Buscar',
      'Group members': 'Miembros del Grupo',
      'Add members': 'Añadir miembros',
      Reload: 'Recargar',
      'Assign permissions to group': 'Asignar permisos al grupo',
      Entity: 'Entidad',
      Roles: 'Roles',
      Role: 'Rol',
      'Permissions Assigned': 'Permisos Asignados',
      'Search Entity': 'Buscar Entidad',
      'Assign new roles to group': 'Asignar nuevos roles al grupo',
      'Are you sure want to unassign': 'Está seguro que quiere desasignar',
      'Assigned roles': 'Roles asginados',
      'Assign roles': 'Asignar roles',
      'Group {0}': 'Grupo {0}',
      Members: 'Miembros',
      Groups: 'Grupos',
      'New group': 'Nuevo grupo',
      'Identity Administration': 'Administración de Identidad',
      'Organizations Management': 'Administración de Organizaciones',
      'Users Management': 'Administración de Usuarios',
      'Roles Management': 'Administración de Roles',
      'Groups Management': 'Administración de Grupos',
      'Permissions Management': 'Administración de Permisos',
      'Role Assignments Management': 'Administración de Asignaciones de Roles',
      Organizations: 'Organizaciones',
      Users: 'Usuarios',
      Assignments: 'Asignaciones',
      Logout: 'Salir',
      'Organization database has been created': 'Base de datos de la organización creada',
      'Something went wrong': 'Algo fue mal',
      'Organization has been blocked': 'La organización fue bloqueada',
      'Organization has been unblocked': 'La organización fue desbloqueada',
      'Is Partner': 'Es Partner',
      'Is Blocked': 'Está Bloqueada',
      'Display Name': 'Nombre a mostrar',
      Email: 'Email',
      'Please enter a valid email': 'Por favor introduzca un email válido',
      Address: 'Dirección',
      'Please enter an address': 'Por favor introduzca una dirección',
      'Partner Organization': 'Organización Partner',
      'Ensure DB': 'Asegurar BD',
      Unblock: 'Desbloquear',
      Block: 'Bloquear',
      'Add members to organization': 'Añadir miembros a la organización',
      'Organization members': 'Miembros de la Organización',
      'Organization {0}': 'Organización {0}',
      'New organization': 'Nueva organización',
      'Creating organization and its database. This could take several minutes. Please wait':
        'Creando la organización y su base de datos. Esto puede tomar varios minutos. Por favor espere',
      'Role Assignments': 'Asignaciones de Roles',
      Identity: 'Identitdad',
      'Select Type': 'Seleccione Tipo',
      Group: 'Grupo',
      'Identity Type': 'Tipo de Identidad',
      'Search Identity': 'Buscar Identidad',
      'New Roles Assignment': 'Nueva Asignación de Roles',
      Visibility: 'Visibilidad',
      'Please select': 'Por favor seleccione',
      Category: 'Categoría',
      'Please enter a category': 'Por favor introduzca una categoría',
      'Assign new roles to permission': 'Asignar nuevos roles al permiso',
      'Permission {0}': 'Permiso {0}',
      'New permission': 'Nuevo permiso',
      Organization: 'Organización',
      'Add role to groups': 'Añadir rol a grupos',
      'Are you sure want remove role from': 'Está seguro que quiere eliminar roles de',
      'Role groups': 'Roles de grupos',
      'Add to groups': 'Añadir a grupos',
      'Add permissions to role': 'Añadir permisos a rol',
      Permission: 'Permiso',
      'Role permissions': 'Permisos del Rol',
      'Add to permissions': 'Añadir a permisos',
      'Add users to role': 'Añadir usuarios al rol',
      'Role users': 'Usuarios del Rol',
      'Add users': 'Añadir usuarios',
      'Role {0}': 'Rol {0}',
      'New role': 'Nuevo rol',
      'Add user to groups': 'Añadir usuario a grupos',
      'Are you sure want remove user from': 'Está seguro que desea eliminar el usuario de',
      'Group membership': 'Membresía a grupo',
      'Assign permissions to user': 'Asignar permisos a usuario',
      'Assign new roles to user': 'Asignar nuevos roles al usuario',
      'User {0}': 'Usuario {0}',
      'Password must match': 'La contraseña debe coincidir',
      'New user': 'Nuevo usuario',
      'Please select an organization': 'Por favor seleccione una organización',
      'Set password': 'Establecer contraseña',
      'Send Invitation': 'Enviar Invitación',
      Password: 'Contraseña',
      'Confirm password': 'Confirmar contraseña',
      'If you leave the password field blank, the system will assume that this user will use an external authentication provider to login':
        'Si deja el campo contraseña en blanco, el sistema asumirá que este usuario usa un sistema externo de authenticación para entrar',
      'Admin zone': 'Zona de Administración',
      'Review Claims': 'Revisar Claims',
      'Review Grants': 'Revisar Grants',
      'Sorry, the page you visited does not exist': 'Lo siento, la página que solicita no existe',
      'Back Home': 'Voler a Inicio',
      'You dont have access to the admin site': 'No tiene acceso al sitio de administración',
      'Redirecting to landing page in': 'Redirigiendo al inicio en',
      Go: 'Ir',
      'Default Language': 'Idioma por Defecto',
      'Please select a language': 'Por favor seleccione un idioma',
      Russian: 'Ruso',
      Portuguese: 'Portugués',
      'Select language': 'Seleccione idioma',
      to: 'a',
      from: 'de',
      'Download template': 'Descargar plantilla',
      'Confirmation required': 'Confirmación requerida',
      'Are you sure do you want to delete all items?': '¿Está seguro que desea eliminar todos los elementos?',
      'Are you sure want to delete selected items?': '¿Está seguro que desea eliminar los elementos selecionados?',
      'Upload complete': 'Subida completada',
      'Delete elements': 'Eliminar elementos',
      'Delete selected': 'Eliminar seleccionados',
      'Bulk upload items': 'Subida masiva de elementos',
      'Delete All': 'Eliminar Todos',
      'Order by': 'Ordenar por',
      'An error ocurred': 'Ha ocurrido un error',
      'No data': 'No hay datos',
      'Reset filter': 'Reiniciar filtro',
      'Select all': 'Seleccionar todo',
      'Filter confirm': 'Confirmar filtro',
      Filter: 'Filtro',
      'Invert selection': 'Invertir selección',
      Sort: 'Ordenar',
      'elements deleted sussessful': 'elementos eliminados satisfactoriamente',
      'Are you sure that you want to discard these changes?': '¿Está seguro que desea desechar los cambios?',
      'Total elements': 'Total de elementos',
      'Total imported': 'Total importado',
      'Download errors file': 'Descargar fichero de errores',
      Errors: 'Errores',
      'Download warnings file': 'Descargar dichero con alertas',
      Warnings: 'Alertas',
      'Deleted elements': 'Elementos eliminados',
      'Fail deletion': 'Eliminaciones fallidas',
      'Not set': 'No establecido',
      "Can't delete own user": 'No puede eliminar su propio usuario',
      "Can't delete own Organization": 'No puede eliminar su propia organización',
    },
    fr: {
      Yes: 'Oui',
      No: 'Non',
      Group: 'Groupe',
      Welcome: 'Bienvenue',
    },
    pt: {
      Welcome: 'Bem-vinda',
    },
    ru: {
      Welcome: 'добро пожаловать',
    },
  },
};
export default i18nGenerated;
